import bridge from "../img/bridge.svg"
import swap from "../img/swap.svg"
import liquidity from "../img/liquidity.svg"

export const MenuItems = [
  {
    title: "Bridge",
    url: "https://bridge.dogechain.dog",
    cName: "nav-links",
    img: bridge,
    isExternal: true,
  },
  {
    title: "Swap",
    url: "/",
    cName: "nav-links",
    img: swap
  },
  {
    title: "Liquidity",
    url: "/liquidity",
    cName: "nav-links",
    img: liquidity
  },
];
